export enum DeliveryTypeOption {
  EMAIL = 'email',
  FAX = 'fax',
  WEB_DOWNLOAD = 'webDownload',
  MAIL = 'mail',
  SMS = 'sms',
}

export const ClientDeliveryTypeOptionValues = [
  DeliveryTypeOption.EMAIL,
  DeliveryTypeOption.FAX,
  DeliveryTypeOption.WEB_DOWNLOAD,
  DeliveryTypeOption.MAIL,
];

export const DriverDeliveryTypeOptionValues = [
  DeliveryTypeOption.EMAIL,
  DeliveryTypeOption.SMS,
];
